import vToggle from "./v-toggle.vue";
import vToggleGroup from "./v-toggle-group.vue";

export default Vue => {
  Vue.component("v-toggle", vToggle);
  Vue.component("v-toggle-group", vToggleGroup);
};
